import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/signIn';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import React from 'react';
import { Link } from 'react-router-dom';
import Spinner from 'theme/Spinner';
import $S from 'theme/settings';

// pageContainer
import StoreSelection from '_pageContainers/storeSelection';

const StoreSelectiongGrid = (pageContext) => {
  localStorage.setItem('localCurrentStaff', null);
  const {
    props: { stores },
    isPending,
    setStorage,
    cleanQuery,
    handleInputChange,
    showPopularStore,
    query,
    inputRef,
    searchResults,
    popularStore,
  } = pageContext;

  if (window.location.href.substr(-1) !== '?') {
    window.location = window.location.href + '?';
  }

  let storesContent;

  if (query.length > 0 && searchResults.length === 0) {
    storesContent = (
      <div className='not-found-wrapper'>
        <p>{$ST.SEARCHED_STORE_NOT_FOUND}</p>
        <button onClick={(e) => cleanQuery(e)}>Clear search</button>
      </div>
    );
  } else if (stores) {
    storesContent = (
      <div className='row'>
        {searchResults.map((store) => {
          const { remote_id } = store;
          const remoteId = $S.hasRemoteId && ` (${remote_id})`;

          return (
            <Link
              className='col-12 col-sm-6 col-md-6 col-xl-4 item_container'
              key={store.id}
              to={$R.LOGIN.path}
              onClick={() => setStorage(store)}
            >
              <div className='user-item pointer'>
                <p className='user-item__title'>{`${store.name}${
                  remoteId || ''
                }`}</p>
                <p className='user-item__content'>
                  {store.address && store.address.township.city.name}
                </p>
              </div>
            </Link>
          );
        })}
      </div>
    );
  } else if (!isPending && stores.length === 0) {
    storesContent = <div className='text-center'>{$ST.STORE_NOT_FOUND}</div>;
  } else if (isPending) {
    storesContent = <Spinner />;
  }

  return (
    <div className='container-fluid headerMargin__onlyLogo'>
      <div className='row'>
        <div className='col-12 col-md-6'>
          <div className='row justify-content-md-center login_form-container'>
            <div className='col-12 col-md-8 login_partial-container bottom-border'>
              <p className='select-lighter text-center'>
                {$ST.SELECT_STORE}
                <br />
                <form>
                  <input
                    className='store-filter-input'
                    placeholder='Find Store'
                    value={query}
                    ref={inputRef}
                    onChange={handleInputChange}
                  />
                </form>
              </p>
            </div>
          </div>

          {popularStore && showPopularStore && (
            <div>
              <div className='col-12 login_partial-container'>
                <p className='select-lighter text-center'>{$ST.LAST_ENTERED_STORE}</p>
              </div>
              <div className='row justify-content-md-center login_form-container popularStoreCard'>
                <Link
                  className='col-12 col-sm-6 col-md-6 col-xl-4 item_container'
                  key={popularStore.id}
                  to={$R.LOGIN.path}
                  onClick={() => setStorage(popularStore)}
                >
                  <div className='user-item pointer'>
                    <p className='user-item__title'>{popularStore.name}</p>
                    <p className='user-item__content'>
                      {popularStore.address &&
                        popularStore.address.township.city.name}
                    </p>
                  </div>
                </Link>
              </div>
            </div>
          )}
        </div>
        <div className='col-12 col-md-6 store-select-wrapper'>
          {storesContent}
        </div>
      </div>
    </div>
  );
};

export default StoreSelection(StoreSelectiongGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/storeSelection/index.js